import LoadingComponent from "../../LoadingComponent";
import { ErrorTemplate } from "../../../templates";
import { usePlaceOrderMutation } from "../../../hooks";

function COD() {
  const {
    mutate: placeOrderMutation,
    status: placeStatus,
    error: placeError
  } = usePlaceOrderMutation();
  let content;
  const orderPlace = async () => {
    placeOrderMutation({ paymentMode: "cod" });
    content = "<h3>Order Place Successfully!!</h3>";
  };

  if (placeStatus === "pending") return <LoadingComponent />;

  if (placeStatus === "error")
    return <ErrorTemplate error={placeError?.message} />;

  content = (
    <div className="payment-right-credit">
      <div className="pay-now-btn">
        <button type="button" className="place-order-btn" onClick={orderPlace}>
          Place Order
        </button>
      </div>
    </div>
  );

  return content;
}

export default COD;
